/*
 * @name: 
 * @Author: zxc
 * @Date: 2021-08-23 08:52:39
 * @LastEditors: zxc
 * @LastEditTime: 2021-10-12 10:10:16
 */
import Layout from '@/layout'

const adminRouter = [
  {
    path: '/adminLogin',
    component: () => import('@/views/admin-back-stage/login/index'),
    hidden: true,
    // name: 'AdminLogin'
  },
  {
    path: '/adminHome',
    component: Layout,
    redirect: '/adminHome/slideshowM',
    name: 'AdminHome',
    meta: {
      title: '首页管理',
      icon: 'nested'
    },
    children: [
      {
        path: 'slideshowM',
        component: () => import('@/views/admin-back-stage/home/slideshow'), // Parent router-view
        name: 'HomeSlideshowM',
        meta: {
          title: '轮播图',
          icon: 'edit'
        }
      },
      {
        path: 'solutionM',
        component: () => import('@/views/admin-back-stage/home/solution'), // Parent router-view
        name: 'HomeSolutionM',
        meta: {
          title: '解决方案',
          icon: 'edit'
        }
      },
      {
        path: 'productM',
        component: () => import('@/views/admin-back-stage/home/product'), // Parent router-view
        name: 'HomeProductM',
        meta: {
          title: '热销产品',
          icon: 'edit'
        }
      },
      {
        path: 'customerM',
        component: () => import('@/views/admin-back-stage/home/customer'), // Parent router-view
        name: 'HomeCustomerM',
        meta: {
          title: '客户案例',
          icon: 'edit'
        }
      },
      {
        path: 'friendsM',
        component: () => import('@/views/admin-back-stage/home/friends'), // Parent router-view
        name: 'HomeFriendsM',
        meta: {
          title: '合作客户',
          icon: 'edit'
        }
      }
    ]
  },
  {
    path: '/adminSolution',
    component: Layout,
    redirect: '/adminSolution/adminSolutionM',
    name: 'AdminSolution',
    meta: {
      title: '解决方案',
      icon: 'nested'
    },
    children: [
      {
        path: 'adminSolutionM',
        component: () => import('@/views/admin-back-stage/solutionM'), // Parent router-view
        name: 'AdminSolutionM',
        meta: {
          title: '解决方案详情管理',
          icon: 'nested'
        }
      },
      {
        path: 'adminSolutionProductM',
        component: () => import('@/views/admin-back-stage/solutionM/product'), // Parent router-view
        name: 'AdminSolutionProductM',
        hidden: true,
        meta: {
          title: '解决方案详情产品管理',
          activeMenu: '/adminSolution/adminSolutionM'
        }
      }
    ]
  },
  {
    path: '/adminProduct',
    component: Layout,
    redirect: '/adminProduct/adminProductArea',
    name: 'AdminProduct',
    meta: {
      title: '产品中心',
      icon: 'nested'
    },
    children: [
      {
        path: 'adminProductArea',
        component: () => import('@/views/admin-back-stage/productM/area'), // Parent router-view
        name: 'AdminProductArea',
        meta: {
          title: '产品分区',
          icon: 'edit'
        }
      },
      {
        path: 'adminProductM',
        component: () => import('@/views/admin-back-stage/productM/index'), // Parent router-view
        name: 'AdminProductM',
        meta: {
          title: '产品管理',
          icon: 'edit'
        }
      },
      {
        path: 'adminProductDetail',
        component: () => import('@/views/admin-back-stage/productM/detail'), // Parent router-view
        name: 'AdminProductDetail',
        hidden: true,
        meta: {
          title: '产品详情',
          icon: 'edit',
          activeMenu: '/adminProduct/adminProductM'
        }
      },
      {
        path: 'adminProductImages',
        component: () => import('@/views/admin-back-stage/productM/images'), // Parent router-view
        name: 'AdminProductImages',
        hidden: true,
        meta: {
          title: '图片管理',
          icon: 'edit',
          activeMenu: '/adminProduct/adminProductM'
        }
      }
    ]
  },
  {
    path: '/adminAbout',
    component: Layout,
    redirect: '/adminAbout/adminAboutM',
    name: 'adminAbout',
    meta: {
      title: '走进丹氏',
      icon: 'nested'
    },
    children: [
      {
        path: 'adminAboutM',
        component: () => import('@/views/admin-back-stage/aboutM/index'), // Parent router-view
        name: 'AdminAboutM',
        meta: {
          title: '走进丹氏管理',
          icon: 'edit'
        }
      },
      // {
      //   path: 'adminjobM',
      //   component: () => import('@/views/admin-back-stage/aboutM/jobM'), // Parent router-view
      //   name: 'AdminjobM',
      //   meta: {
      //     title: '招贤纳士',
      //     icon: 'edit'
      //   }
      // },
      {
        path: 'adminactivityM',
        component: () => import('@/views/admin-back-stage/aboutM/activityM'), // Parent router-view
        name: 'AdminactivityM',
        meta: {
          title: '公司活动',
          icon: 'edit'
        }
      },
      {
        path: 'adminactivityD',
        component: () => import('@/views/admin-back-stage/aboutM/activityD'), // Parent router-view
        name: 'AdminactivityD',
        hidden: true,
        meta: {
          title: '公司活动更改',
          icon: 'edit'
        }
      }
    ]
  },
  // {
  //   path: '/adminservicesAndSupport',
  //   component: Layout,
  //   redirect: '/adminservicesAndSupport/adminservicesAndSupportM',
  //   name: 'AdminservicesAndSupport',
  //   meta: {
  //     title: '服务于支持',
  //     icon: 'nested'
  //   },
  //   children: [
  //     {
  //       path: 'adminservicesAndSupportM',
  //       component: () => import('@/views/admin-back-stage/servicesAndSupportM/index'), // Parent router-view
  //       name: 'AdminservicesAndSupportM',
  //       meta: {
  //         title: '服务与支持',
  //         icon: 'nested'
  //       }
  //     }
  //   ]
  // }
]

export default adminRouter



// WEBPACK FOOTER //
// ./src/router/admin.js